export enum PLAN_REQUEST_STATUS {
  APPROVE = 'A',
  REJECT = 'R',
  PENDING = 'P',
  DELETE = 'D',
}
export interface HoslogRequestPlans {
  sno: number;
  clubId: string;
  clubImage: {
    alt: string;
    description: string;
    path: string;
  };
  planId?: string;
  planRequestId?: string;
  storeNameEng: string;
  storeNameJp: string;
  planTitle: string;
  planPrice: number;
  nomination: number;
  status: PLAN_REQUEST_STATUS;
  requestedDate: number;
}
